// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5416":"6bd57d77c69f8c20","5641":"e37212bf517f6a32","8977":"deaa78d8d782291d"}[chunkId] + ".css";
};